module.exports = __webpack_public_path__ + "img/74400.106402f6.jpg";